<template>
	<div>
		<q-table
			ref="table"
			:data="tests"
			:columns="columns_tests"
			row-key="id"
			:pagination.sync="pagination_tests"
			@request="requestTests"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td key="title" :props="props">
						<span v-if="props.row.title.length > 49">
							{{ `${props.row.title.substring(0, 50)}...` }}
							<q-tooltip>{{ props.row.title }}</q-tooltip>
						</span>
						<span v-else>
							{{ props.row.title }}
						</span>
					</q-td>

					<q-td key="live_class_test_type" :props="props">
						{{ $t(getTestType(props.row.live_class_test_type)) }}
					</q-td>

					<q-td key="qty_questions" :props="props">
						{{ props.row.qty_questions }}
					</q-td>

					<q-td key="minimum_score" :props="props">
						{{ props.row.minimum_score }}
					</q-td>

					<q-td key="test_score" :props="props">
						{{ props.row.test_score }}
					</q-td>

					<q-td key="qty_user_results" :props="props">
						{{ props.row.qty_user_results }}
					</q-td>

					<q-td key="status" :props="props" auto-width>
						<q-chip
							small
							:icon="getIconStatusTest(props.row.status)"
							:color="getColorStatusTest(props.row.status)"
							class="full-width text-center"
						>
							{{ $t(getTextStatusTest(props.row.status)) }}
						</q-chip>
					</q-td>

					<q-td auto-width key="actions" :props="props">
						<q-btn
							flat
							round
							color="primary"
							icon="far fa-chart-line"
							@click="showTestDetails(props.row)"
						>
							<q-tooltip>
								{{ $t('average_results_tooltip') }}
							</q-tooltip>
						</q-btn>
						<q-btn
							flat
							round
							color="secondary"
							icon="far fa-users"
							@click="showTestUsers(props.row)"
						>
							<q-tooltip>
								{{ $t('participants_report_tooltip') }}
							</q-tooltip>
						</q-btn>
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<q-modal
			v-model="show_test_users"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_test_users = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ test.title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						ref="table"
						:data="users"
						:columns="columns_users"
						row-key="user_id"
						:pagination.sync="pagination_users"
						@request="requestUserTests"
						:loading="loading"
						:no-data-label="$t('no_data_avaliable')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						:filter="filter_users"
						binary-state-sort
						class="q-mt-lg"
					>
						<template slot="top" slot-scope="props" :props="props">
							<q-search
								v-model="filter_users"
								icon="far fa-search"
								:placeholder="$t('search')"
								:debounce="500"
							/>

							<div class="col" />
							<q-btn
								color="secondary"
								class="q-mr-sm"
								icon="fas fa-download"
								:label="$t('tests_report')"
								@click="downloadReport()"
							/>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<template slot="body" slot-scope="props">
							<q-tr
								:props="props"
								class="cursor-pointer"
								@click.native="showTestUsersResult(props.row)"
							>
								<q-td key="full_name" :props="props">
									{{ props.row.full_name }}
								</q-td>

								<q-td key="email" :props="props">
									{{ props.row.email }}
								</q-td>

								<q-td key="result_date" :props="props">
									{{ fDate(props.row.result_date) }}
								</q-td>

								<q-td key="time_to_answer" :props="props">
                                    {{ fTime(props.row.time_to_answer, 'HH:mm:ss') }}
                                </q-td>

								<q-td key="qty_questions" :props="props">
									{{ props.row.qty_questions }}
								</q-td>

								<q-td key="score" :props="props">
									{{ props.row.score }}
								</q-td>

								<q-td key="percent" :props="props">
									{{
										props.row.percent ? `${props.row.percent.toFixed(2)}%` : ''
									}}
								</q-td>

								<q-td key="test_score" :props="props">
									{{ props.row.test_score }}
								</q-td>

								<q-td key="status" :props="props" auto-width>
									<q-chip
										small
										:icon="getIconStatusUser(props.row.status)"
										:color="getColorStatusUser(props.row.status)"
										class="full-width text-center"
										v-if="props.row.status"
									>
										{{ $t(getTextStatusUser(props.row.status)) }}
									</q-chip>
								</q-td>
							</q-tr>
						</template>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_test_users_result"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_test_users_result = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ test.title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm justify-end question-list">
						<div
							class="col-xs-12 col-sm-12"
							v-for="(question, index) in test_result"
							:key="index"
						>
							<span :class="getQuestionClass(index, question)">
								{{ index + 1 }}) <span v-html="question.title"></span>
							</span>

							<q-field :error="question.error">
								<q-option-group
									type="radio"
									v-model="question.user_answer_id"
									:options="question.answers"
									class="questions q-mt-xs"
									:class="question.is_correct ? 'checkbox-hit' : 'checkbox-error'"
									@input="question.error = false"
									readonly
								/>
							</q-field>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_test_results"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn
						flat
						round
						dense
						@click="show_test_results = false"
						icon="fas fa-times"
					/>
					<q-toolbar-title>
						{{ test.title }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm justify-end question-list">
						<q-btn
							color="secondary"
							v-if="permissions"
							class="q-mr-sm"
							icon="fas fa-download"
							:label="$t('tests_report')"
							@click="downloadReportModel()"
						/>
						<div
							class="col-xs-12 col-sm-12"
							v-for="(question, index) in test_results"
							:key="index"
						>
							<!-- <p class="q-subheading text-weight-medium q-mb-xs" :id="'qt' + question.id">
                                {{ index + 1 }}) {{ question.question }}
                            </p> -->

							<span :class="getQuestionClass(index, question)">
								{{ `${index + 1})` }} <span v-html="question.question"></span>
							</span>

							<q-field :error="question.error">
								<q-option-group
									type="radio"
									v-model="question.answer_correct_id"
									:options="question.answers"
									class="questions q-mt-xs"
									@input="question.error = false"
									readonly
								/>
							</q-field>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
const { formatDate } = date

export default {
	props: ['load', 'id', 'permissions'],

	data() {
		return {
			pagination_tests: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			pagination_users: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
			columns_tests: [
				{
					name: 'title',
					required: true,
					label: 'title',
					align: 'left',
					field: 'title',
					sortable: true,
				},
				{
					name: 'live_class_test_type',
					required: true,
					label: 'type',
					align: 'left',
					field: 'live_class_test_type',
					sortable: true,
				},
				{
					name: 'qty_questions',
					required: true,
					label: 'questions',
					align: 'left',
					field: 'qty_questions',
					sortable: true,
				},
				{
					name: 'minimum_score',
					required: true,
					label: 'minimum_score',
					align: 'left',
					field: 'minimum_score',
					sortable: true,
				},
				{
					name: 'test_score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'test_score',
					sortable: true,
				},
				{
					name: 'qty_user_results',
					required: true,
					label: 'qty_user_test_results',
					align: 'left',
					field: 'qty_user_results',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
				{
					name: 'actions',
					required: true,
					label: '',
					align: 'left',
					field: 'actions',
					sortable: false,
				},
			],
			columns_users: [
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'result_date',
					required: true,
					label: 'date',
					align: 'left',
					field: 'result_date',
					sortable: true,
				},
                {
                    name: 'time_to_answer',
                    required: true,
                    label: 'time',
                    align: 'left',
                    field: 'time_to_answer',
                    sortable: true,
                },
				{
					name: 'qty_questions',
					required: true,
					label: 'questions',
					align: 'left',
					field: 'qty_questions',
					sortable: true,
				},
				{
					name: 'score',
					required: true,
					label: 'correct',
					align: 'left',
					field: 'score',
					sortable: true,
				},
				{
					name: 'percent',
					required: true,
					label: 'percent',
					align: 'left',
					field: 'percent',
					sortable: true,
				},
				{
					name: 'test_score',
					required: true,
					label: 'score',
					align: 'left',
					field: 'test_score',
					sortable: true,
				},
				{
					name: 'status',
					required: true,
					label: 'status',
					align: 'left',
					field: 'status',
					sortable: true,
				},
			],
			tests: [],
			users: [],
			test: {},
			test_result: [],
			test_results: [],
			show_test_users: false,
			show_test_users_result: false,
			show_test_results: false,
			loading: false,
			filter_users: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_language_selected: 'common/id_user_language_selected',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			return this.$q.platform.is.mobile ? '100vw' : '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},
	},

	methods: {
		requestTests({ pagination }) {
			this.loading = true
			this.pagination_tests = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.pagination_tests.rowsPerPage,
				page: this.pagination_tests.page,
				ordering: order_by,
			}

			this.savePaginationTests()

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/tests/?${this.$qs.stringify(
						data
					)}`,
					this.getHeader
				)
				.then((response) => {
					this.pagination_tests.rowsNumber = response.data.count

					this.tests = response.data.results.map((e) => {
						return { ...e, actions: e.id }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		requestUserTests({ pagination }) {
			this.loading = true
			this.pagination_users = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.pagination_users.rowsPerPage,
				page: this.pagination_users.page,
				ordering: order_by,
				search: this.filter_users,
			}

			this.savePaginationUsers()

			this.$axios
				.get(
					`/admin_live_classes/live_classes/${this.id}/tests/${
						this.test.id
					}/user_attempts/?${this.$qs.stringify(data, { arrayFormat: 'repeat' })}`,
					this.getHeader
				)

				.then((response) => {
					this.pagination_users.rowsNumber = response.data.count

					this.users = response.data.results.map((e) => {
						return { ...e }
					})
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.loading = false
				})
		},

		showTestUsers(row) {
			this.test = row
			this.show_test_users = true

			this.requestUserTests({
				pagination: this.pagination_tests,
			})
		},

		showTestUsersResult(row) {
			if (row.id) {
				this.$q.loading.show()

				this.$axios
					.get(
						`/admin_live_classes/live_classes/${this.id}/tests/${
							this.test.id
						}/user_attempts/result/?attempt_id=${row.id}`,
						this.getHeader
					)

					.then((response) => {
						this.test_result = response.data.questions.map((e) => {
							return {
								...e,
								answers: e.live_class_test_question_answers.map((g) => {
									return { ...g, label: g.title, value: g.id }
								}),
							}
						})
						this.show_test_users_result = true
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		showTestDetails(row) {
			if (row.id) {
				this.test = row
				this.$q.loading.show()

				this.$axios
					.get(
						`/admin_live_classes/live_classes/${this.id}/tests/${
							row.id
						}/user_attempts/test_analyse/`,
						this.getHeader
					)
					.then((response) => {
						this.test_results = response.data.live_class_test_questions.map((e) => {
							return {
								...e,
								answers: e.answers.map((g) => {
									return {
										...g,
										label: `${g.title} (${
											g.qty_answered
										} / ${g.percent_answered.toFixed(2)}%)`,
										value: g.id,
									}
								}),
							}
						})

						this.show_test_results = true
					})
					.catch((e) => {
						console.log(e)
					})
					.finally(() => {
						this.$q.loading.hide()
					})
			}
		},

		downloadReportModel() {
			const message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})

			this.$axios
				.get(
					`admin_live_classes/live_classes/${this.id}/tests/${
						this.test.id
					}/user_attempts/generate_report_test_analyse/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		downloadReport() {
			const message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`admin_live_classes/live_classes/${this.id}/tests/${
						this.test.id
					}/user_attempts/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		getTestType(type) {
			if (type === 1) {
				return 'conventional_test'
			} else if (type === 2) {
				return 'block_test'
			} else if (type === 3) {
				return 'restart_test'
			} else if (type === 4) {
				return 'unevaluated_quiz'
			} else if (type === 5) {
				return 'evaluated_quiz'
			} else if (type === 6) {
				return 'block_general_test'
			} else if (type === 7) {
				return 'restart_general_test'
			}
		},

		getQuestionClass(index, question) {
			let return_class = ''
			if (index != 0) return_class += 'q-mt-md'
			if (question.error) return_class += ' text-negative'
			return return_class
		},

		fDate(d) {
			if (d) {
				let format = ''

				switch (this.id_user_language_selected) {
					case 1:
					case 3:
						format = 'DD/MM/YYYY HH:mm:ss'
						break
					default:
						format = 'MM-DD-YYYY HH:mm:ss'
						break
				}

				return date.formatDate(d, format)
			}
		},
		
        fTime(d) {
            if (d) {
                const [hours, minutes, seconds] = d.split(':');
                const time = new Date();
                time.setHours(parseInt(hours));
                time.setMinutes(parseInt(minutes));
                time.setSeconds(parseFloat(seconds));
                return date.formatDate(time, 'HH:mm:ss');
            }
        },

		getTextStatusTest(status) {
			if (status === 1) return 'published_f'
			else if (status === 2) return 'unpublished_f'
			else if (status === 3) return 'deleted_f'
		},

		getTextStatusUser(status) {
			if (status === 1) return 'approved'
			else if (status === 2) return 'reproved'
			else if (status === 3) return 'blocked'
			else if (status === 4) return 'restart'
			else if (status === 5) return 'improved'
		},

		getColorStatusTest(status) {
			if (status === 1) return 'positive'
			else if (status === 2) return 'warning'
			else if (status === 3) return 'negative'
		},

		getColorStatusUser(status) {
			if (status === 1) return 'positive'
			else if (status === 2) return 'negative'
			else if (status === 3) return 'negative'
			else if (status === 4) return 'info'
			else if (status === 5) return 'positive'
		},

		getIconStatusTest(status) {
			if (status === 1) return 'fal fa-check'
			else if (status === 2) return 'fal fa-alert'
			else if (status === 3) return 'fal fa-times'
		},

		getIconStatusUser(status) {
			if (status === 1) return 'fal fa-check'
			else if (status === 2) return 'fal fa-file-times'
			else if (status === 3) return 'fal fa-times'
			else if (status === 4) return 'fal fa-clock'
			else if (status === 5) return 'fal fa-file-check'
		},

		savePaginationTests() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_tests.rowsPerPage])
		},

		savePaginationUsers() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.pagination_users.rowsPerPage])
		},

		loadPagination() {
			this.pagination_tests.rowsPerPage = this.num_rows
			this.pagination_users.rowsPerPage = this.num_rows
		},
	},

	watch: {
		load: function() {
			if (this.load) {
				this.requestTests({ pagination: this.pagination_tests })
			}
		},

		num_rows: {
			handler: function(newValue) {
				this.loadPagination()
			},
			deep: true,
		},
	},

	created() {
		this.loadPagination()

		this.requestTests({ pagination: this.pagination_tests })
	},
}
</script>

<style></style>
